<template>
  <form class="cd-form">
    <div class="form-group is-empty">
      <div class="input-icon">
        <i class="ti-email"></i>
        <input
          type="text"
          id="sender-email"
          class="form-control"
          name="email"
          placeholder="Email"
          v-model="emailFormField"
        />
      </div>
      <span class="material-input"></span>
    </div>
    <strong class="pa-3">
      <ul v-if="errors.length > 0" style="color: red">
        <li v-for="(error, index) in errors" v-text="error" :key="index"></li>
      </ul>
    </strong>

    <p class="fieldset">
      <button
        class="btn btn-common log-btn"
        type="button"
        v-on:click="resetPassword"
      >
        Réinitialiser mon mot de passe
      </button>
    </p>
  </form>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";
export default {
  name: "ResetPasswordForm",
  data() {
    return {
      emailFormField: null,
      errors: [],
      afterResetUrl: "",
    };
  },
  props: {
    nextUrl: String,
  },
  created() {
    this.afterResetUrl =
      "/my-account?reset-password-request=true&nextUrl=" + this.nextUrl;
  },
  methods: {
    checkForm() {
      let isValid = true;
      this.errors = [];
      if (this.emailFormField === null) {
        this.errors.push("L'email est obligatoire");
        isValid = false;
      } else if (this.emailFormField.trim() === "") {
        this.errors.push("L'email est obligatoire");
        isValid = false;
      } else if (!this.validateEmail(this.emailFormField)) {
        isValid = false;
        this.errors.push("L'email est invalide.");
      }
      return isValid;
    },
    resetPassword() {
      if (this.checkForm()) {
        const httpClient = new HttpClient();
        httpClient
          .resetPassword({
            email: this.emailFormField,
          })
          .then(() => {
            window.location.href = this.afterResetUrl;
          })
          .catch((error) => {
            console.error(error);
            alert("Une erreur s'est produite.");
          });
      }
    },
    validateEmail: function (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },
};
</script>

<style scoped></style>
